<template>
  <ChartCard title="Avg Productivity Percentile" infoText="Norm benchmark — higher is better" chartHeight="240px" :headerColor="chartColors.productivity">
    <LineChart v-if="dataPoints.length" :data="lineData" :options="lineOptions" />
  </ChartCard>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, PointElement, LineElement, CategoryScale, LinearScale)

import ChartCard from './ChartCard.vue'
import { chartColors } from '../../assets/chartColors.js'

export default {
  name: 'ProductivityLineChart',
  components: { LineChart, ChartCard },
  props: {
      dataPoints: { type: Array, default: () => [] },
    labels: { type: Array, default: () => ['1', '2', '3'] }
  },
  data() {
    return { chartColors }
  },
  computed: {
    lineData() {
      const labels = this.dataPoints.length > 0 ? Array.from({ length: this.dataPoints.length }, (_, i) => String(i + 1)) : []
      return {
        labels: labels,
        datasets: [{
          data: this.dataPoints,
          borderColor: this.chartColors.productivity,
          backgroundColor: this.chartColors.productivity,
          borderWidth: 3,
          pointBackgroundColor: this.chartColors.productivity,
          pointRadius: 6,
          pointHoverRadius: 8,
          tension: 0.1,
          spanGaps: false
        }]
      }
    },
    lineOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { callbacks: { label: (ctx) => ctx.raw != null ? `${ctx.raw}` : '' } } },
        scales: {
          x: { grid: { display: false }, ticks: { stepSize: 1, color: '#333' } },
          y: { min: 0, max: 100, grid: { color: '#f0f0f0' }, ticks: {         stepSize: 10, color: '#333' } }
        }
      }
    }
  }
}
</script>
